import React from 'react';
import { ArrayElementType } from '../../types/utils/ArrayElementType';
import { CommonProps } from '../Element/Element';
import Div from '../Element/Div/Div';
import styles from './Gutter.module.scss';

type GutterProps = {
  /** Gutter class name */
  className?: string | number | Record<string, unknown> | [];
  /** Make gutter half size */
  half?: boolean;
  /** Make gutter quarter size */
  quarter?: boolean;
  /** Gutter size */
  size?: SupportedGutterSize;
} & CommonProps<'div'>;
// Alias for backwards compatibility
export type GutterAttributes = GutterProps;

const Gutter: React.FunctionComponent<GutterProps> = ({
  className,
  half,
  quarter,
  size = (half && 'half') || (quarter && 'quarter') || 'md',
  ...props
}: GutterProps) => {
  const classNames = [
    styles.gutter,
    {
      [styles.gutter__zero]: size === 'zero',
      [styles.gutter__half]: size === 'half',
      [styles.gutter__quarter]: size === 'quarter',
      [styles.gutter__sizeXxs]: size === 'xxs',
      [styles.gutter__sizeXs]: size === 'xs',
      [styles.gutter__sizeSm]: size === 'sm',
      [styles.gutter__sizeMd]: size === 'md',
      [styles.gutter__sizeLg]: size === 'lg',
      [styles.gutter__sizeXlg]: size === 'xlg',
      [styles.gutter__layout_1]: size === 'layout-1',
      [styles.gutter__layout_2]: size === 'layout-2',
      [styles.gutter__layout_3]: size === 'layout-3',
      [styles.gutter__layout_4]: size === 'layout-4',
      [styles.gutter__layout_5]: size === 'layout-5',
      [styles.gutter__layout_6]: size === 'layout-6',
      [styles.gutter__layout_7]: size === 'layout-7',
      [styles.gutter__layout_8]: size === 'layout-8',
      [styles.gutter__layout_9]: size === 'layout-9',
    },
    className,
  ];

  return <Div className={classNames} {...props} />;
};

export const supportedGutterSizes = [
  'zero',
  'xxs',
  'xs',
  'sm',
  'md',
  'lg',
  'xlg',
  'xxlg', //This should be removed when breaking happens, since it's not doing anything
  'half',
  'quarter',
  'layout-1',
  'layout-2',
  'layout-3',
  'layout-4',
  'layout-5',
  'layout-6',
  'layout-7',
  'layout-8',
  'layout-9',
] as const;

export type SupportedGutterSize = ArrayElementType<typeof supportedGutterSizes>;
export default Gutter;
